export interface ICompany {
  allowedToOperate: boolean
  authorizedForBroker: boolean
  authorizedForProperty: boolean
  brokerAuthorityStatus: string
  carrierOperation: string
  commonAuthorityStatus: string
  companyName: string
  contractAuthorityStatus: string
  emailAddress: string
  faxNumber: string
  id: string
  isHazmat: boolean
  mcNumber: string
  mcsData: {
    mcisAddDate: string
    mcs150Date: string
    mcs150Mileage: string
    mcs150MileageYear: string
  }
  numberOfDrivers: string
  numberOfPowerUnits: string
  phoneNumber: string
  /**
   * The company's physical address as registered with the FMCSA
   */
  physicalAddress:
    | {
        city: string
        country: string
        state: string
        street: string
        zip: string
      }
    | undefined
}

export type TCompanyVerificationMethods = {
  verificationMethods: { type: string; value: string }[] | null
}

/**
 * The possible values for verifying a workspace
 */
export enum VerificationMethodEnum {
  CompanyEmail = 'CompanyEmail',
  ComplianceEmail = 'ComplianceEmail',
  Custom = 'Custom',
  Email = 'Email',
  Phone = 'Phone'
}

export enum ReceiveCodeMethodEnum {
  Email = 'Email',
  PhoneCall = 'PhoneCall',
  SMS = 'SMS'
}
